/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxProgressBarModule } from 'devextreme-angular';

import { SysqueProgressBarComponent } from './sysque-progress-bar.component';

@NgModule({
  declarations: [SysqueProgressBarComponent],
  imports: [CommonModule, DxProgressBarModule],
  exports: [SysqueProgressBarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueProgressBarModule {}
